import * as React from 'react';
import './index.scss';
import HourRank from '@hooks/web/public/hourRank.tsx';
import GroupChamption from '@hooks/web/public/groupChamption.tsx';
import RichRank from '@hooks/web/public/richRank.tsx';
import PkRank from '@hooks/web/public/pkRank.tsx';
const { useEffect } = React;
const Final: React.FC = () => {
  useEffect(() => {
  }, [])
  return (
    <div
      className='final'
    >
      <GroupChamption iStage={4} />
      <HourRank iStage={4} />
      <RichRank />
      <PkRank iStage={4} from={1} iRevive={0}/>
    </div>
  )
}

export default Final;